import { h } from 'preact';
import { t } from '../../theme/locales';
const Controls = ({ index , stepsCount , nextDisabled , onBack , onNext , nextLabel =null , saving =false  })=>{
    const children = [];
    if (index > 0) {
        children.push(h('button', {
            type: 'button',
            onClick: onBack,
            className: 'o-button o-button--hollow gift-wrapping__controls__back',
            tabIndex: 0
        }, t('gift_wrapping.steps.controls.back')));
    }
    const defaultLabel = index < stepsCount - 1 ? t('gift_wrapping.controls.continue') : t('gift_wrapping.controls.add_to_bag');
    const label = saving ? t('gift_wrapping.steps.controls.adding') : nextLabel || defaultLabel;
    children.push(h('button', {
        type: 'button',
        onClick: onNext,
        disabled: nextDisabled || saving,
        className: 'o-button gift-wrapping__controls__next',
        'data-testid': 'gift-wrapping-next-button',
        tabIndex: nextDisabled || saving ? -1 : 0
    }, label));
    return h('div', {
        className: 'gift-wrapping__controls'
    }, children);
};
export default Controls;
